import { render } from "./SelectProjectForPackages.vue?vue&type=template&id=433a9826&scoped=true"
import script from "./SelectProjectForPackages.vue?vue&type=script&lang=js"
export * from "./SelectProjectForPackages.vue?vue&type=script&lang=js"

import "./SelectProjectForPackages.vue?vue&type=style&index=0&id=433a9826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433a9826"]])

export default __exports__